import { useField, UseFieldConfig } from "react-final-form";

import { CheckboxProps, FormControl, FormControlLabel, FormControlProps, FormHelperText, styled } from "@mui/material";
// eslint-disable-next-line no-restricted-imports
import Checkbox from "@mui/material/Checkbox";

const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
    marginTop: 0,
    marginLeft: theme.spacing(8),
    "&.Mui-error": {
        color: theme.palette.emteria.error,
    },
}));
export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    "&:hover": {
        backgroundColor: "transparent",
    },
    "&.Mui-checked": {
        color: theme.palette.emteria.primary,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    "&.MuiCheckbox-indeterminate": {
        color: theme.palette.emteria.primary,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
}));
const StyledFormControlLabel = styled(FormControlLabel)({
    marginBottom: 0,
    padding: 0,
    margin: 0,
    maxWidth: "100%",
    alignItems: "flex-start",

    "& .MuiFormControlLabel-label": {
        whiteSpace: "normal",
    },
});

interface ControlledCheckboxFieldProps extends CheckboxProps {
    name: string;
    label?: React.ReactNode;
    helperText?: string;
    config?: UseFieldConfig;
}

export const ControlledCheckboxField = ({ name, config, label, helperText, ...rest }: ControlledCheckboxFieldProps) => {
    const { input, meta } = useField<boolean>(name, { ...config, type: "checkbox" });
    const error = meta.touched && meta.error;

    return (
        <FormControl error={error} component="fieldset">
            <StyledFormControlLabel control={<StyledCheckbox {...input} {...rest} />} label={label} />
            <StyledFormHelperText>{error || helperText}</StyledFormHelperText>
        </FormControl>
    );
};

interface CheckboxFieldProps extends CheckboxProps {
    label?: React.ReactNode;
    helperText?: string;
    controlProps?: FormControlProps;
}
export const CheckboxField = ({ controlProps, ...props }: CheckboxFieldProps) => {
    return (
        <FormControl {...controlProps}>
            <StyledFormControlLabel control={<StyledCheckbox {...props} />} label={props.label} />
            <StyledFormHelperText>{props.helperText}</StyledFormHelperText>
        </FormControl>
    );
};
